import { useEffect } from 'react';
import parseCookieString from '@justpark/helpers/src/parseCookieString/parseCookieString';
import { useDispatch } from 'react-redux';
import { showWithCta } from '@justpark/snackbar/src/reducers/snackbar';

const NoCacheSnackBar = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    const cookies = parseCookieString(document.cookie);
    const hasCookie = 'jp_nocache' in cookies;

    if (hasCookie && cookies.jp_nocache === 'true') {
      dispatch(
        showWithCta('Landing page cache bypassed', 'Enable Cache', {
          type: 'REMOVE_NO_CACHE_COOKIE'
        })
      );
    }
  }, [dispatch]);

  return null;
};

export default NoCacheSnackBar;
